import styled from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor/views/Anchor';

export const StyledBackToResultsLink = styled(Anchor)`
  color: black;
`;

export const StyledBackArrow = styled.span`
  border: solid ${(props) => props.theme.colors.BLACK};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 5px;
  transform: rotate(135deg);
`;

export const StyledBackLabel = styled.span`
  padding: 0 0 0 16px;
  color: ${(props) => props.theme.colors.BLACK};
  font-weight: 500;
`;
